// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"e60b4246","453":"d68947c8"}[chunkId] + ".chunk.js";
};